import { CSSProperties } from "react";

export const styles: { [key: string]: CSSProperties } = {
  link: {
    display: "block",
    padding: 1,
    cursor: "pointer",
    textDecoration: "none",
    color: "#000",
  },
};
